(()=>{
const root=document.querySelector('.ta[data-audience="training-at-home"]');
if(!root)return;
const $=selector=>root.querySelector(selector);
const rawLang=document.documentElement.lang||'en';
let strings={};
try{strings=JSON.parse($('#ta-strings').textContent)||{};}catch(error){strings={};}
const t=(key,vars)=>{let text=strings[key]||'';for(const name in (vars||{}))text=text.replace('{'+name+'}',vars[name]);return text;};

/* Tabbed viewer: keyboard and aria follow the house pattern. */
const tabs=Array.from(root.querySelectorAll('[data-tab]'));
const video=$('#ta-platform-video'),foldImage=$('#ta-fold-image'),videoPlay=$('#ta-platform-play');
function resetVideo(){if(!video)return;video.pause();video.hidden=true;if(foldImage)foldImage.hidden=false;if(videoPlay)videoPlay.hidden=false;}
function choose(tab,focus){
 tabs.forEach(other=>{
  const on=other===tab;
  other.setAttribute('aria-selected',String(on));
  other.tabIndex=on?0:-1;
  const panel=document.getElementById(other.getAttribute('aria-controls'));
  if(panel)panel.hidden=!on;
 });
 resetVideo();
 if(focus)tab.focus();
}
tabs.forEach((tab,i)=>{
 tab.addEventListener('click',()=>choose(tab,false));
 tab.addEventListener('keydown',event=>{
  const next={ArrowRight:(i+1)%tabs.length,ArrowLeft:(i+tabs.length-1)%tabs.length,Home:0,End:tabs.length-1}[event.key];
  if(next!==undefined){event.preventDefault();choose(tabs[next],true);}
 });
});
if(videoPlay&&video)videoPlay.addEventListener('click',()=>{
 if(foldImage)foldImage.hidden=true;
 video.hidden=false;
 videoPlay.hidden=true;
 video.play().catch(()=>{});
});

/* Mobile sticky action: shown only while the hero, package, demo and close band are off screen. */
const sticky=$('.ta-mobile-action');
const visible=new Map();
if(sticky&&'IntersectionObserver' in window){
 const observer=new IntersectionObserver(entries=>{
  entries.forEach(entry=>visible.set(entry.target,entry.isIntersecting));
  sticky.hidden=[...visible.values()].some(Boolean);
 },{threshold:.05});
 [$('.ta-hero'),$('#ta-setup'),$('#ta-demo'),$('.ta-close')].forEach(section=>{if(section)observer.observe(section);});
}

/* Live price, saving and Premium Care value from the store's own product JSON. */
function withArrow(link,text){link.textContent=text+' ';const arrow=document.createElement('span');arrow.setAttribute('aria-hidden','true');arrow.textContent='→';link.appendChild(arrow);}
const routeRoot=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
const abort=new AbortController();
const timer=setTimeout(()=>abort.abort(),8000);
function fetchProduct(handle){
 return fetch(routeRoot+'products/'+handle+'.js',{signal:abort.signal}).then(response=>{if(!response.ok)throw new Error('Unavailable');return response.json();});
}
const unavailable=root.hasAttribute('data-ta-unavailable');
if(!unavailable)Promise.all([
 fetchProduct('speediance-gym-monster-3'),
 fetchProduct('speediance-premium-care-2-year-in-home-service-plan').catch(()=>null)
]).then(([product,premiumCare])=>{
 const studioId=($('#ta-main')||{dataset:{}}).dataset.taStudio||'';
 const usable=v=>v.available&&Number(v.price)>0;
 const variant=(product.variants||[]).find(v=>studioId&&String(v.id)===studioId&&usable(v))||(product.variants||[]).find(v=>usable(v)&&String(v.sku||'').toUpperCase()==='GM3STUDIO')||(product.variants||[]).find(v=>usable(v)&&(v.public_title||v.title||'').trim().toLowerCase()==='gym monster 3 / studio');
 if(!variant)return;
 const currency=product.currency||(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active);
 if(!currency)return;
 const money=amount=>new Intl.NumberFormat(rawLang,{style:'currency',currency,currencyDisplay:'narrowSymbol',minimumFractionDigits:0,maximumFractionDigits:amount%100?2:0}).format(amount/100);
 const vat=Number(root.dataset.vat)||0;
 const withVat=cents=>vat?Math.ceil(cents*(1000+vat)/100000)*100:cents;
 const price=withVat(Number(variant.price)),compareAt=Number(variant.compare_at_price||0)?withVat(Number(variant.compare_at_price)):0;
 const hasSaving=compareAt>price;
 const save=hasSaving?compareAt-price:0;
 const priceText=money(price);
 const productUrl=location.origin+routeRoot+'products/speediance-gym-monster-3?variant='+encodeURIComponent(variant.id);
 const priceEl=$('#ta-price');priceEl.textContent=priceText;priceEl.href=productUrl;priceEl.setAttribute('aria-label',(product.title||'Gym Monster 3')+', '+priceText);
 if(hasSaving){
  $('#ta-price-compare-value').textContent=money(compareAt);$('#ta-price-compare').hidden=false;
  const saveEl=$('#ta-price-save');saveEl.textContent=t('save',{save:money(save)});saveEl.hidden=false;
 }
 const ctaText=hasSaving?t('cta_save',{save:money(save)}):t('cta');
 [$('#ta-hero-cta'),$('#ta-close-cta')].forEach(link=>{if(link){link.textContent=ctaText;link.href=productUrl;}});
 const productLink=$('#ta-product-link');
 if(productLink){withArrow(productLink,hasSaving?t('product_link_save',{price:priceText}):t('product_link'));productLink.href=productUrl;}
 const stickyCta=$('#ta-sticky-cta');
 if(stickyCta){withArrow(stickyCta,hasSaving?t('sticky_save',{save:money(save)}):t('sticky'));stickyCta.href=productUrl;}
 root.querySelectorAll('.ta-product-copy .ta-link').forEach(link=>{link.href=productUrl;});
 if(variant.featured_image&&variant.featured_image.src){const productImg=$('#ta-product-image');if(productImg)productImg.src=variant.featured_image.src;}
 const careVariant=premiumCare&&Array.isArray(premiumCare.variants)?premiumCare.variants[0]:null;
 const careValue=careVariant&&Number(careVariant.price)>0?money(withVat(Number(careVariant.price))):null;
 const careEl=$('#ta-care-value');
 if(careEl&&careValue)careEl.textContent=t('care_value',{value:careValue});
}).catch(()=>{}).finally(()=>clearTimeout(timer));

/* Rating line: the average the Loox rebuild renders on the Gym Monster 3 product page (.bm-proof__avg). Only an unambiguous single match is used; no review count is shown. */
const ratingAbort=new AbortController();
const ratingTimer=setTimeout(()=>ratingAbort.abort(),8000);
(unavailable?Promise.reject(new Error('Unavailable')):fetch(routeRoot+'products/speediance-gym-monster-3',{signal:ratingAbort.signal})).then(response=>{if(!response.ok)throw new Error('Unavailable');return response.text();}).then(html=>{
 const matches=new DOMParser().parseFromString(html,'text/html').querySelectorAll('.bm-proof__avg');
 if(matches.length!==1)return;
 const average=Number(String(matches[0].textContent).trim().replace(',','.'));
 if(!(average>0&&average<=5))return;
 const rating=average.toLocaleString(rawLang,{minimumFractionDigits:1,maximumFractionDigits:1});
 const ratingEl=$('#ta-rating'),textEl=$('#ta-rating-text');
 if(ratingEl&&textEl){textEl.textContent=t('rating',{rating});ratingEl.hidden=false;}
}).catch(()=>{}).finally(()=>clearTimeout(ratingTimer));
})();
